import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=7148f577&scoped=true&"
import script from "./SButton.vue?vue&type=script&lang=ts&"
export * from "./SButton.vue?vue&type=script&lang=ts&"
import style0 from "./SButton.vue?vue&type=style&index=0&id=7148f577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7148f577",
  null
  
)

export default component.exports